<template>
  <div>
    <v-card class="quoteSideInfo">
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{paIcon}}</v-icon>
          Personal Accident
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn flat slot="activator" @click="doSave()" :loading="quotation.saving">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
          <span>Save Quotation/Proposal</span>
        </v-tooltip>
        <v-tooltip top>
          <v-menu bottom left slot="activator">
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="promptNTU = true">
                <v-list-tile-title>Not Taken Up</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="promptVoid = true">
                <v-list-tile-title>Void</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <span>More Options</span>
        </v-tooltip>
      </v-toolbar>
      <template v-if="!value">
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs4>
                <v-subheader class="queryLabel">Quotation No.</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{commonForm.proposalNo}}</span>
              </v-flex>
              <template v-if="commonInfo.premium.premiumPayable">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Premium Payable</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span class="title">{{currPrefix}}{{formatDisplayNumber(commonInfo.premium.premiumPayable)}}</span>
                </v-flex>
              </template>
              <v-flex xs4>
                <v-subheader class="queryLabel">Current Status</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{currentStatusLabel}}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">Intermediary</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{intermediary}}</span>
              </v-flex>
              <template v-if="commonForm.product">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Product</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{product}}</span>
                </v-flex>
              </template>
              <template v-if="paForm.noAdult != null">
                <v-flex xs4>
                  <v-subheader class="queryLabel">No. of Adult(s)</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{paForm.noAdult}}</span>
                </v-flex>
              </template>
              <template v-if="paForm.noChild != null">
                <v-flex xs4>
                  <v-subheader class="queryLabel">No. of Child(ren)</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{paForm.noChild}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.schemeDesc">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Scheme</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{commonForm.schemeDesc}}</span>
                </v-flex>
              </template>
              <template v-if="paForm.planNo && plan !== ''">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Plan</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{plan}}</span>
                </v-flex>
              </template>
              <template v-if="paForm.paType">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Cover Type</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{coverType[paForm.paType]}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.startDate">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Acceptance Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{formatDisplayDateTime2(commonForm.acceptDate)}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.startDate">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Start Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{formatDate(commonForm.startDate)}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.endDate">
                <v-flex xs4>
                  <v-subheader class="queryLabel">End Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{formatDate(commonForm.endDate)}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.discLdg && commonForm.discLdg.length > 0">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Loadings</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <ul>
                    <li v-for="discLdg in commonForm.discLdg" :key="discLdg">
                      {{discLdgDesc(discLdg)}}
                    </li>
                  </ul>
                </v-flex>
              </template>
              <template v-if="commonForm.campaign">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Campaign</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{campaign}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.promotion">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Promotion</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{promotion}}</span>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card-text>
      </template>
    </v-card>
    <confirm v-model="promptNTU" @ok="doNTU">
      Confirm that you want to change the status of this Quotation to
      <b>Not Taken Up</b>?
    </confirm>
    <confirm v-model="promptVoid" @ok="doVoid">
      Confirm that you want to change the status of this Quotation to
      <b>Void</b>?
    </confirm>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { extractLabel } from '@/utils/extract'
import { formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { quoteStatus, appIcon } from '@/const/underwriting'
import { paType } from '@/const/underwriting/pa'

export default {
  data() {
    return {
      promptNTU: false,
      promptVoid: false
    }
  },
  computed: {
    quotation() {
      return this.$store.state.agency.quotation
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    },
    currentStatusLabel() {
      if (quoteStatus[this.quotation.commonInfo.statusCode]) {
        return quoteStatus[this.quotation.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    paForm() {
      return this.quotation.paForm
    },
    commonForm() {
      return this.quotation.commonForm
    },
    commonInfo() {
      return this.quotation.commonInfo
    },
    paParam() {
      return this.quotation.paParam
    },
    intermediary() {
      return extractLabel(this.$store.state.agency.quotationSettings.intermediaries, this.quotation.commonForm.intermediary)
    },
    product() {
      return extractLabel(this.paParam.product, this.commonForm.product)
    },
    tripType() {
      return ''
    },
    paArea() {
      return extractLabel(this.paParam.paArea, this.paForm.paArea)
    },
    paType() {
      return ''
    },
    campaign() {
      return extractLabel(this.paParam.campaign, this.commonForm.campaign)
    },
    promotion() {
      return extractLabel(this.paParam.promotion, this.commonForm.promotion)
    },
    paIcon() {
      return appIcon.PA
    },
    plan() {
      if (this.paParam.plans.plans !== undefined && this.paParam.plans.plans !== null && this.paForm.planNo !== undefined && this.paForm.planNo !== null) {
        let label = ''
        for (var i = 0; i < this.paParam.plans.plans.length; i++) {
          const arr = this.paParam.plans.plans[i]
          if (arr.planNo === this.paForm.planNo) {
            label = arr.planDesc
            break
          }
        }
        return label
      } else {
        return ''
      }
    },
    coverType() {
      return paType || {}
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime2(date) {
      return formatDisplayDateTime2(date)
    },
    doSave() {
      // Emit saving event on global event bus
      // Each quote page should listen to this and do partial Submit and save
      this.$root.$emit('saveQuote')
    },
    async doNTU() {
      this.$root.$emit('ntu')
    },
    doVoid() {
      this.$root.$emit('void')
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    discLdgDesc(discLdg) {
      if (discLdg && this.paParam.discLdg && this.paParam.discLdg.length > 0) {
        const discLdgParam = this.paParam.discLdg.find(x => x.discLdg === discLdg)
        if (discLdgParam) {
          return discLdgParam.discLdgDesc
        }
      }
      return ''
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@media (min-width: 1264px) {
  .quoteSideInfo {
    // Module specific override
    min-height: 425px;
  }
}

.permitStatus {
  padding-left: 20px;
}
</style>
